/*
 * @Author: pluto.guo 66291979@qq.com
 * @Date: 2024-12-06 19:27:40
 * @LastEditors: pluto.guo 66291979@qq.com
 * @LastEditTime: 2024-12-26 13:42:09
 * @FilePath: /lobby/src/common/updateService.js
 * @Description:
 *
 * Copyright (c) 2024 by ${git_name_email}, All Rights Reserved.
 */
// import { Http } from '@capacitor/http'
import { useUserStore } from '@/stores/user'
import { Directory, Filesystem } from '@capacitor/filesystem'

export const VERSION_JSON_URL = `https://res.megalake.games/app/version.json?timestamp=${Date.now()}` // 替换为 CDN JSON 文件的路径
// 检查是否有新版本
export async function checkForUpdate(currentVersionCode) {
  try {
    // 使用 fetch 获取 JSON 文件
    const response = await fetch(VERSION_JSON_URL, {
      cache: 'no-cache' // 避免缓存问题
    })

    if (!response.ok) {
      throw new Error(`网络请求失败，状态码: ${response.status}`)
    }

    const { staging, production } = await response.json()

    const versionCode =
      __APP_ENV__ == 'app_staging'
        ? staging[useUserStore().country].versionName
        : production[useUserStore().country].versionName
    // 检查版本号
    if (compareVersion(versionCode, currentVersionCode) > 0) {
      return __APP_ENV__ == 'app_staging'
        ? staging[useUserStore().country].apkUrl
        : production[useUserStore().country].apkUrl // 返回 APK 文件下载链接
    }

    return null // 无需更新
  } catch (error) {
    console.error('Error checking for update:', error)
    return null
  }
}

function compareVersion(version1, version2) {
  const v1 = version1.split('.').map((num) => parseInt(num, 10)) // 将版本号拆分并转换为数字
  const v2 = version2.split('.').map((num) => parseInt(num, 10))

  // 比较每个数字部分
  for (let i = 0; i < Math.max(v1.length, v2.length); i++) {
    const part1 = v1[i] || 0 // 如果长度不一致，补充为 0
    const part2 = v2[i] || 0

    if (part1 > part2) return 1 // version1 大于 version2
    if (part1 < part2) return -1 // version1 小于 version2
  }

  return 0 // 版本号相等
}

// 下载并保存 APK 文件
export async function downloadAndSaveAPK(apkUrl) {
  try {
    // 通过 fetch 下载 APK 文件
    const response = await fetch(apkUrl, {
      cache: 'no-cache' // 避免缓存问题
    })

    if (!response.ok) {
      throw new Error(`APK 下载失败，状态码: ${response.status}`)
    }

    const blob = await response.blob()

    // 将 Blob 转换为 Base64
    const reader = new FileReader()
    reader.readAsDataURL(blob)

    const base64 = await new Promise((resolve, reject) => {
      reader.onloadend = () => resolve(reader.result.split(',')[1]) // 提取 Base64 数据部分
      reader.onerror = reject
    })

    // 保存到本地文件系统
    const fileName = 'update.apk'
    await Filesystem.writeFile({
      path: fileName,
      data: base64,
      directory: Directory.External
    })

    return `${Directory.External}/${fileName}`
  } catch (error) {
    console.error('下载 APK 时发生错误:', error)
    throw error
  }
}
